import { ToastOptions } from "react-toastify";

export const defaultToastProps: ToastOptions = {
    position: 'bottom-right',
    autoClose: 5000,
    rtl: false,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    draggable: true,
    pauseOnHover: true,
};
